var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuditB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 24.6753L99 163.273L204 221.175V82.4164L100 24.6753Z",
    fill: "#B2E8C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.623 90.1871L133 123.61L149.006 132.991L148.369 164.175L169 132.185C163.46 128.822 157.885 125.517 152.344 122.154C152.437 111.459 152.542 100.823 152.623 90.1753V90.1871Z",
    fill: "#72D09A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.538 16.6752L100 24.6752L204.022 82.6752C209.352 79.9984 214.682 77.3098 220 74.633C185.513 55.3177 151.014 36.0023 116.526 16.6752H116.538Z",
    fill: "#72D09A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M219 210.499C213.996 214.054 208.993 217.62 204 221.175V82.6753L220 74.6753L219 210.511V210.499Z",
    fill: "#29A063"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109 35.1753V53.5651L136 70.1753C135.896 63.7709 135.78 57.3787 135.676 50.9743C126.788 45.708 117.9 40.4416 109 35.1753Z",
    fill: "#72D09A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.205 182.567V193.896C108.205 198.286 104.958 202.659 98.4477 205.936C85.5168 212.617 64.4792 212.617 51.5303 205.936C45.1102 202.659 41.8457 198.286 41.8457 193.896V182.567H108.205Z",
    fill: "#FEE4E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4834 195.263C85.5216 201.706 64.5289 201.706 51.5671 195.263C38.6053 188.82 38.6053 178.384 51.5671 171.957C64.5289 165.514 85.5216 165.514 98.4834 171.957C111.445 178.399 111.445 188.836 98.4834 195.263Z",
    fill: "#FECECA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3534 193.205C83.6754 198.497 66.3752 198.497 55.6972 193.205C45.0192 187.914 45.0192 179.321 55.6972 174.015C66.3752 168.723 83.6754 168.723 94.3534 174.015C105.031 179.306 105.031 187.899 94.3534 193.205Z",
    fill: "#FEE4E2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6872 176.762L100.692 181.003C100.692 184.769 98.2219 188.521 93.2672 191.331C83.4267 197.063 67.417 197.063 57.5627 191.331C52.677 188.521 50.1927 184.769 50.1927 181.003L50.1589 178.41L99.6872 176.762Z",
    fill: "#FEE4E2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2945 187.305C83.4305 192.117 67.4549 192.117 57.5909 187.305C47.7269 182.493 47.7269 174.699 57.5909 169.899C67.4549 165.087 83.4305 165.087 93.2945 169.899C103.159 174.71 103.159 182.505 93.2945 187.305Z",
    fill: "#FECECA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0494 185.835C81.9797 189.824 68.9056 189.824 60.8359 185.835C52.7663 181.846 52.7663 175.369 60.8359 171.368C68.9056 167.379 81.9797 167.379 90.0494 171.368C98.119 175.357 98.119 181.835 90.0494 185.835Z",
    fill: "#FEE4E2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M119.835 113.142L92.1772 161.046C91.106 162.901 88.8296 164.052 85.6052 164.036C79.1585 164.08 71.3229 159.556 68.1304 153.947C66.5387 151.182 66.3901 148.631 67.4613 146.776L95.1187 98.8721L119.835 113.142Z",
    fill: "#FEE4E2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M113.307 116.086C106.873 116.082 99.0538 111.567 95.833 105.997C92.6121 100.426 95.2151 95.9177 101.646 95.9285C108.08 95.9326 115.899 100.447 119.12 106.017C122.341 111.588 119.738 116.096 113.307 116.086Z",
    fill: "#F97E73"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M112.338 114.346C107.008 114.319 100.513 110.569 97.8245 105.966C95.1364 101.364 97.2814 97.6485 102.615 97.6685C107.945 97.6953 114.44 101.445 117.128 106.048C119.817 110.65 117.672 114.366 112.338 114.346Z",
    fill: "#FECECA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M102.544 132.506C103.975 132.1 105.12 132.323 105.813 133.011L152.319 186.47L142.554 195.43L96.8449 142.413C96.0631 141.762 95.7601 140.601 96.1341 139.104C96.8442 136.263 99.7135 133.309 102.544 132.506Z",
    fill: "#F97E73"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M151.802 191.803C150.067 194.958 145.883 196.624 143.767 196.094C142.558 195.791 142.027 194.944 141.701 193.803C141.081 191.637 142.982 188.5 145.84 186.511C148.699 184.52 151.29 184.804 152.424 186.681C153.269 187.984 152.438 190.547 151.802 191.803Z",
    fill: "#FECECA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditB);
export default __webpack_public_path__ + "static/media/auditB.f4bf5ce4adfdc47cb2e43ab693ccdb0c.svg";
export { ForwardRef as ReactComponent };